import { API_PATH } from 'constants/app';
import { InvoiceStatusFilter, NUMBER_ITEMS_PER_REQUEST } from 'constants/invoice';
import { api } from 'helper/api';
import { formatE164Phone } from 'helper/form';
import { Invoice, InvoiceForm, InvoicePage, InvoicePayment } from 'models/invoice';

export function query(pageNumber: number, statusFilter: InvoiceStatusFilter): Promise<InvoicePage> {
  return api.build().get(`${API_PATH}/accounts/me/invoices`, {
    page: pageNumber,
    size: NUMBER_ITEMS_PER_REQUEST,
    status: statusFilter === InvoiceStatusFilter.ALL ? undefined : statusFilter
  })
  .then((invoicePage: InvoicePage) => {
    return { ...invoicePage, status: statusFilter };
  });
}

export function create(invoiceForm: InvoiceForm): Promise<Invoice> {
  return api.build().post(`${API_PATH}/accounts/me/invoices`, {
    items: invoiceForm.items,
    recipient: {
      name: invoiceForm.recipient.name,
      phone: formatE164Phone(invoiceForm.recipient.phone)
    }
  });
}

export function getDetail(invoiceId: string): Promise<Invoice> {
  return api.build().withoutAuth().get(`${API_PATH}/invoices/${invoiceId}`);
}

export function update(invoice: Invoice): Promise<Invoice> {
  return api.build().patch(`${API_PATH}/accounts/me/invoices/${invoice.id}`, {
    items: invoice.items,
    recipient: {
      name: invoice.recipient.name,
      phone: formatE164Phone(invoice.recipient.phone)
    }
  });
}

export function remove(invoice: Invoice): Promise<Invoice> {
  return api.build().delete(`${API_PATH}/accounts/me/invoices/${invoice.id}`);
}

export function createPayment(invoice: Invoice): Promise<InvoicePayment> {
  return api.build().withoutAuth().post(`${API_PATH}/invoices/${invoice.id}/payment`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/invoice.ts